"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDataGridContextValues_unstable", {
    enumerable: true,
    get: ()=>useDataGridContextValues_unstable
});
const _useTableContextValues = require("../Table/useTableContextValues");
function useDataGridContextValues_unstable(state) {
    const tableContextValues = (0, _useTableContextValues.useTableContextValues_unstable)(state);
    return {
        ...tableContextValues,
        dataGrid: {
            ...state.tableState,
            focusMode: state.focusMode,
            selectableRows: state.selectableRows,
            subtleSelection: state.subtleSelection,
            selectionAppearance: state.selectionAppearance,
            resizableColumns: state.resizableColumns
        }
    };
} //# sourceMappingURL=useDataGridContextValues.js.map

//# sourceMappingURL=useDataGridContextValues.js.map